import { createPortal } from 'react-dom'

const ComplaintsPolicyModal = ({ onClose }: { onClose: () => void }) => {
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">Complaints Policy</div>
          <div className="pf-content__description">
            <p>
              This policy sets out our complaints policy. If you are a User of <a href='/' className='terms-link'>www.allfans.com</a> (“Website”), this 
              policy forms part of your agreement with us. Defined terms have the same meanings as in our <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
            </p>
          </div>
          <ol className="pf-main-list">
            <li><h5>Applicability</h5>
              <p>Whether or not you are a User, you can use this policy to alert us to any complaint 
                that you have relating to the Website.</p>
            </li>
            <li>  
              <h5>How to Make a Complaint</h5>
              <p>
                If you have a complaint about the Website (including any complaint about Content appearing on the Website or the 
                conduct of a User), please send your complaint to abuse@allfans.com, including your name, address, contact details, 
                a description of your complaint, and, if your complaint relates to Content, the URL for the Content to which your 
                complaint relates. If you cannot contact us by email, please write to us at the mailing address identified in section 7.
              </p>
            </li>
            <li>
              <h5>Complaints of Illegal or Nonconsensual Content</h5>
              <p>
                After receiving your complaint of illegal or nonconsensual Content under section 2, 
                (1) we will in good faith investigate your complaint, and all reported complaints 
                WILL BE resolved within 5 business days; (2) if we require further information or 
                documents from you, we will contact you to let you know; (3) if we are satisfied that 
                the Content is unlawful or nonconsensual, we will immediately remove that Content, 
                and we will notify you of our decision by email or other electronic message; and 
                (4) if we are satisfied that the Content is not unlawful or nonconsensual, we will 
                notify you of our decision by email or other electronic message. Any dispute regarding 
                our determination that Content is nonconsensual will be submitted by us to a neutral 
                arbitration association at our expense.
              </p>
              </li>
            <li>
              <h5>Content Removal Policy</h5>
              <p>
                Innodev Solutions Inc ("AllFans") have the absolute right to remove any Content that we believe, in our sole 
                discretion, may violate any law or the Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a>. We comply with all 
                applicable laws regarding the use of proportionate measures to quickly remove illegal Content when we 
                become aware it is on our Site. We are not responsible for any loss you claim to have suffered because 
                of any action we take, in accordance with Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a>, to remove 
                Content.  
              </p>
              <p>
                Content Moderation and Removal: All Content is reviewed prior to being published and regularly 
                monitored to ensure all Content complies with the Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a> and 
                applicable laws. Any violative Content, including without limitation, Content that is harmful, unlawful, 
                offensive, or otherwise objectionable, will be rejected and/or immediately removed from the Site. If you 
                identify content you believe to be violating any of the <a href='/terms' className='termslink'>Terms of Service</a> or Innodev Solutions Inc ("AllFans"), 
                please immediately report it by emailing <a href='mailto:support@allfans.com' className='termslink'>support@allfans.com</a>.
              </p>
              <p>
                For any other requests for removal of Content, please email us at <a href='mailto:support@allfans.com' className='termslink'>support@allfans.com</a>. Include as much 
                information so we can investigate the removal request, such as name of 
                location on site, brief description, date and time of identification and any relevant URLs and or 
                screenshots. If a request is missing important information, we may not be able to properly investigate 
                the claim to remove the content. 
              </p>
              <p>
                We review all requests for content removal as soon as practicable but in no event more than five (5) 
                business days.
              </p>
              </li>
            <li>
              <h5>Complaints of Copyright Infringement</h5>
              <p>
                Complaints related to copyright infringement must be submitted to our copyright agent in 
                accordance with our <a href='/dmca' className='terms-link'>DMCA Policy</a>, and we will respond to copyright infringement complaints 
                as set out in that policy.
              </p>
              </li>
            <li>
              <h5>All Other Complaints</h5>
              <p>
                After receiving any other complaint (including complaints related to other breaches of 
                the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, the <a href='/creatorterms' className='terms-link'>Creator Terms</a>, 
                or the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>) under 
                section 2, (1) we will take those steps as we consider to be appropriate to investigate your 
                complaint within a timeframe that is appropriate to the nature of your complaint; (2) if we 
                require further information or documents from you, we will contact you to let you know; and 
                (3) we will in good faith take those actions as we consider appropriate to deal with the issue 
                that your complaint has raised. If you have complained about the Content that appears on the 
                Website and we are satisfied that the Content otherwise breaches the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, 
                the <a href='/creatorterms' className='terms-link'>Creator Terms</a>, or 
                the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>, we will act promptly 
                to remove that Content. We are not required to inform you of the outcome of your complaint.
              </p>
            </li>
            <li>
              <h5>Unjustified or Abusive Complaints</h5>
              <p>
                If you are a User, you state that you will not make any complaint under this policy that is 
                wholly unjustified, abusive, or made in bad faith. If we determine that you have breached this 
                warranty, we may suspend or terminate your User account.
              </p>
            </li>
            <li>
              <h5>Contact Information</h5>
              <p>
                The Website is owned and operated by Innodev Solutions Inc., a Delaware corporation. You can 
                write to us at 2108 N ST #6819, SACRAMENTO, CA 95816 or at abuse@allfans.com. All notices of copyright infringement 
                claims should be sent to the copyright agent designated in our <a href='/dmca' className='terms-link'>DMCA Policy</a> in the manner and by 
                the means set out in it.
              </p>
            </li>
          </ol>
          </div>  
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default ComplaintsPolicyModal
